import Proxy from './Proxy';

class CommonProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/common', parameters);
  }

  /**
   * role 리스트
   * @returns {Promise}
   */
  roleFindAll() {
    return this.submit('get', `${this.endpoint}/roles`);
  }

  findId( data ) {
    return this.submit('post', `${this.endpoint}/advertiser/find-id`, data )
  }

  existsUserId( userId ) {
    userId = encodeURIComponent( userId )
    return this.submit('get', `${this.endpoint}/advertiser/join/check-userid/${userId}`)
  }

  validLicense( companySeq, license ) {
    return this.submit('post', `${this.endpoint}/advertiser/license-compare/${companySeq}`, { license })
  }

  validCaptcha( value ) {
    return this.submit('post', `${this.endpoint}/captcha/valid`, { value })
  }

  createUser( data ) {
    return this.submit('post', `${this.endpoint}/advertiser/create`, data )
  }

  resetPwd( data ) {
    return this.submit('post', `${this.endpoint}/advertiser/reset-pwd`, data )
  }

  pwdConfirm( uuid ) {
    return this.submit('get', `${this.endpoint}/advertiser/pwd-confirm/${uuid}` )
  }

  resetPwdByAdmin( userId ) {
    return this.submit('get', `${this.endpoint}/advertiser/reset-pwd/${userId}` )
  }

  changePw( data ) {
    return this.submit('post', `${this.endpoint}/change-pwd`, data )
  }

}

export default CommonProxy;
